import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

/**
 * Ajustes de shell nativo (Capacitor) aplicados no boot. No PWA/web é no-op.
 *
 * - Status bar: o app é tema claro (fundo cream/branco, texto escuro), então
 *   usamos `Style.Light` = ícones/texto ESCUROS sobre fundo claro, com a barra
 *   pintada de cream (#F1EDE4, o `background_color` da marca) e sem sobrepor o
 *   webview (a barra tem espaço próprio).
 * - Splash: escondemos assim que a UI monta (o nativo ainda tem auto-hide de
 *   fallback configurado no capacitor.config.ts, então nunca fica preso).
 */
export async function initNativeShell(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await StatusBar.setStyle({ style: Style.Light });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#F1EDE4' });
      await StatusBar.setOverlaysWebView({ overlay: false });
    }
  } catch {
    /* status bar é não-crítico — não trava o boot */
  }

  try {
    await SplashScreen.hide();
  } catch {
    /* já escondida / indisponível */
  }
}
